// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap';
// Smoothscroll
// import { SmoothScroll } from "./smoothscroll.js";

document.addEventListener('DOMContentLoaded', function(event) {

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    // new SmoothScroll(document,240,3);
});



